import React from 'react'
import { H1, H2, H4, P } from '@drifthq/tide-core'

import boltTrioPink from './../bolt-trio-pink.svg'

import videoWithConvoSrc from './../assets/video-convo.jpg'
import logoRowSrc from './../assets/logo-row.jpg'
import hiredPhotoSrc from './../assets/hired-photo.jpg'
import hiredLogoSrc from './../assets/hired-logo.jpg'

import { InstallButton } from './../index'

const AppSwitcherInstallVariant = ({ onInstallClick }) => (
  <div>
    <div className="drift-getting-started-container">
      <div className="drift-getting-started">
        <div className="drift-install-content">
          <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
          <H1 className="drift-getting-started-title">
            Record and share videos that start conversations right in your Drift inbox.
          </H1>
          <P className="drift-getting-started-subtitle">
            Getting started is super simple. Just install the Drift Video Chrome Extension - it&rsquo;ll take
            30 seconds!
          </P>
          <InstallButton onInstallClick={onInstallClick} copy="Add Drift Video to Chrome" showArrow={true} />
          <P>You already have a free account!</P>
        </div>
      </div>
      <img className="drift-install-image" src={videoWithConvoSrc} alt="laptop-with-face" />
    </div>
    <div className="drift-install-education-container education-section-blue">
      <div className="drift-install-section-header">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <H2 className="drift-getting-started-title">How Drift Video works</H2>
      </div>
      <div className="drift-install-item-row">
        <div className="drift-getting-started-educational-card">
          <span role="img" aria-label="pointing right">
            📹
          </span>
          <H4>Record in one click</H4>
          <P>Easily record and share videos that start conversations in just three clicks.</P>
        </div>
        <div className="drift-getting-started-educational-card">
          <span role="img" aria-label="pointing right">
            🔔
          </span>
          <H4>Get notified of views</H4>
          <P>Get notified on desktop and mobile when someone watches your videos.</P>
        </div>
        <div className="drift-getting-started-educational-card">
          <span role="img" aria-label="pointing right">
            💬
          </span>
          <H4>Start conversations</H4>
          <P>Chat with prospects in real time while they watch your videos.</P>
        </div>
      </div>
      <InstallButton onInstallClick={onInstallClick} copy="Add Drift Video to Chrome" />
    </div>
    <div className="drift-install-education-container">
      <div className="drift-install-section-header">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <H2 className="drift-getting-started-title">You&rsquo;re in good company</H2>
      </div>
      <img className="drift-install-logo-row" src={logoRowSrc} alt="zappi, hired, sigstr, and gong.io" />
      <div className="drift-install-item-row">
        <img className="drift-install-hired-testimonial-photo" src={hiredPhotoSrc} alt="Ben Cherian, SDR at Hired" />
        <div className="drift-install-hired-testimonial">
          <P className="testimonial-body">
            "Our prospects have so many requests for their attention making it hard to differentiate yourself. 
            With Drift Video, we're able to cut through all of the noise and build personal connections that 
            help us get our foot in the door.”
          </P>
          <P className="testimonial-name">Ben Cherian</P>
          <P>SDR, Hired</P>
          <img className="drift-install-hired-logo" src={hiredLogoSrc} alt="Hired logo" />
        </div>
      </div>
    </div>
    <div className="drift-install-education-container install-footer blue-graffiti-bg">
      <div className="drift-install-section-header">
        <H2 className="drift-getting-started-title">Ready to create videos that start conversations? Simply install the Chrome Extension to get started.</H2>
      </div>
      <InstallButton onInstallClick={onInstallClick} copy="Add Drift Video to Chrome" showArrow={true} />
      <P className="button-subcopy">You already have a free account!</P>
    </div>
  </div>
)

export default AppSwitcherInstallVariant



// WEBPACK FOOTER //
// ./src/layouts/VideoInstallStep/variants/app-switcher-install-component.js